import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  CardText,
  CardTitle,
  Col,
  Container,
  Row,
  Spinner,
} from "reactstrap";
import LineColumnChart from "./LineColumnChart";
import PieChart from "./PieChart";
import "./pieChart.scss";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

const AppStatusAndAnalysis = ({ loanStatsData, loading }) => {
  useEffect(() => {
    if (loanStatsData) {
      console.log(loanStatsData);
    }
  }, [loanStatsData]);
  return (
    <div className="justify-content-center">
      <Row>
        <Col xl={8}>
          <Card style={{ borderRadius: "20px", height: "400px" }}>
            <CardBody>
              <LineColumnChart />
            </CardBody>
          </Card>
        </Col>
        <Col xl={4}>
          <Card style={{ borderRadius: "20px", minHeight: "400px" }}>
            {loading ? (
              <div className="text-center" style={{ marginTop: "40px" }}>
                <Spinner className="mr-2" color="success" />
              </div>
            ) : (
              <CardBody>
                <h4 style={{ fontWeight: "bold" }}>Application Status:</h4>

                <div className="pie-para">
                  <div className="paras">
                    <Link to={{ pathname: "/loan-list/Approved By Bank" }}>
                      <p
                        style={{
                          border: "1px solid #18a07a",
                          backgroundColor: "#ddf8ee",
                          color: "#18a07a",
                          borderRadius: "12px",
                          // paddingLeft: "5px",
                          fontSize: "13px",
                          // textAlign: "left",
                          display: "flex",
                          width: "200px",
                          justifyContent: "space-between",
                          paddingLeft: "10px",
                          paddingRight: "5px",
                        }}
                      >
                        <p style={{ margin: "0", textAlign: "right" }}>
                          Approved By Bank{" "}
                        </p>{" "}
                        | {loanStatsData?.bank_approved_loans <10 ? `0${loanStatsData?.bank_approved_loans}`:loanStatsData?.bank_approved_loans}
                      </p>
                    </Link>
                    <Link to={{ pathname: "/loan-list/Pending Bank Approval" }}>
                      <p
                        style={{
                          border: "1px solid #3fb3cc",
                          backgroundColor: "#d8f8ff",
                          color: "#3fb3cc",
                          borderRadius: "12px",
                          // paddingLeft: "5px",
                          fontSize: "13px",
                          // textAlign: "left",
                          display: "flex",
                          width: "200px",
                          justifyContent: "space-between",
                          paddingLeft: "10px",
                          paddingRight: "5px",
                        }}
                      >
                        Pending Bank Approval{" "}
                        <p style={{ margin: "0", textAlign: "right" }}>
                          | {loanStatsData?.beythak_approved_loans <10 ? `0${loanStatsData?.beythak_approved_loans}` : loanStatsData?.beythak_approved_loans }
                        </p>
                      </p>
                    </Link>
                    <Link
                      to={{ pathname: "/loan-list/Pending Beythak Approval" }}
                    >
                      <p
                        style={{
                          border: "1px solid #f3a24b",
                          backgroundColor: "#fff1e2",
                          color: "#f3a24b",
                          borderRadius: "12px",
                          // paddingLeft: "5px",
                          fontSize: "13px",
                          // textAlign: "left",
                          display: "flex",
                          width: "200px",
                          justifyContent: "space-between",
                          paddingLeft: "10px",
                          paddingRight: "5px",
                        }}
                      >
                        Pending Beythak Approval{" "}
                        <p style={{ margin: "0", textAlign: "right" }}>
                          | {loanStatsData?.pending_loans <10 ? `0${loanStatsData?.pending_loans}`:loanStatsData?.pending_loans}
                        </p>
                      </p>
                    </Link>
                    <Link to={{ pathname: "/loan-list/Rejected By Beythak" }}>
                      <p
                        style={{
                          border: "1px solid #e06f70",
                          backgroundColor: "#fbe7e9",
                          color: "#e06f70",
                          borderRadius: "12px",
                          // paddingLeft: "5px",
                          fontSize: "13px",
                          // textAlign: "left",
                          display: "flex",
                          width: "200px",
                          justifyContent: "space-between",
                          paddingLeft: "10px",
                          paddingRight: "5px",
                        }}
                      >
                        Rejected By Beythak{" "}
                        <p style={{ margin: "0", textAlign: "right" }}>
                          | {loanStatsData?.beythak_rejected_loans <10 ? `0${loanStatsData?.beythak_rejected_loans}` : loanStatsData?.beythak_rejected_loans}
                        </p>
                      </p>
                    </Link>
                    <Link to={{ pathname: "/loan-list/Rejected By Bank" }}>
                      <p
                        style={{
                          border: "1px solid #d84848",
                          backgroundColor: "#fbe7e9",
                          color: "#d84848",
                          borderRadius: "12px",
                          // paddingLeft: "5px",
                          fontSize: "13px",
                          // textAlign: "left",
                          display: "flex",
                          width: "200px",
                          justifyContent: "space-between",
                          paddingLeft: "10px",
                          paddingRight: "5px",
                        }}
                      >
                        Rejected By Bank{" "}
                        <p style={{ margin: "0", textAlign: "right" }}>
                          {" "}
                          | {loanStatsData?.bank_rejected_loans < 10 ? `0${loanStatsData?.bank_rejected_loans}`: loanStatsData?.bank_rejected_loans}
                        </p>
                      </p>
                    </Link>
                    <Link to={{ pathname: "/loan-list/Under Review" }}>
                      <p
                        style={{
                          border: "1px solid #727272",
                          backgroundColor: "#f6f7fa",
                          color: "#727272",
                          borderRadius: "12px",
                          // paddingLeft: "5px",
                          fontSize: "13px",
                          // textAlign: "left",
                          display: "flex",
                          width: "200px",
                          justifyContent: "space-between",
                          paddingLeft: "10px",
                          paddingRight: "5px",
                        }}
                      >
                        Bank Not Reviewed{" "}
                        <p style={{ margin: "0", textAlign: "right" }}>
                          {" "}
                          | {loanStatsData?.bank_not_reviewed <10 ? `0${loanStatsData?.bank_not_reviewed}` : loanStatsData?.bank_not_reviewed}
                        </p>
                      </p>
                    </Link>
                  </div>
                  {/* <div className="w-20" style={{ width: "100%" }}> */}
                    <PieChart loanStatsData={loanStatsData} />
                  {/* </div> */}
                </div>
              </CardBody>
            )}
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default AppStatusAndAnalysis;
